import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const [files_image, set_files_image] = useState([]);
	const [, set_image_base64] = useState([])

	const [img_loader, set_img_loader] = useState([])

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
			.then(res => {

				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const uploadFilesImage = async (files, order, type, langid, lang) => {
		let aux = []
		return await files.forEach(async (element) => {
			if(element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				return await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', getTokenInfo().companycode)
		formData.append('uniqid', '')
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then(async (res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				dados.current.info.image = {
					id: i,
					url: res.data.path + '/' + res.data.name,
					link: res.data.path + '/' + res.data.name,
					type: res.data.mimetype,
					size: res.data.size,
					date: today_file
				}

				await reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 

						reqPOST(`${api_crud_base}/multimedia`, x)
							.then(() => {

								let y2 = img_loader
								y2.pop()
								set_img_loader(y2)
								setRefresh(i)

							})
							.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			console.log('props.location.state', props.location.state)

			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)
				set_show_delete_button(true)

				set_image_base64([])

				fetch_id_info(props.location.state.item.id).then(() => {
					console.log('dados.current', dados.current)
					setLoading(false)
					//setRefresh(refresh + 1)
				})
				return
			}
			else {
				set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1)
				setLoading(false)
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then(async (result) => {
				if (result.isConfirmed) {

					files_image.forEach(async (el_image) => {
						if (el_image !== null) {
							if (el_image.files.length > 0) {
								await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
							}
						}
					})
					set_files_image([])
					set_image_base64([])


					console.log('dados.current', dados.current)

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					files_image.forEach(async (el_image) => {
						if (el_image !== null) {
							if (el_image.files.length > 0) {
								await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
							}	
						}
					})
					set_files_image([])
					set_image_base64([])

					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}


		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if(name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if(aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if(el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		dados.current.info[name] = value

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

		
	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if(dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if(aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if(el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if(name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	
	}

	const handle_change_info_color = (e) => {
		const { name, value } = e.target;

		if(dados.current.info.color === undefined) {
			dados.current.info.color = {primary: '', primary_rgb: '', secondary: ''}
		}

		let color_rgb = hex2rgb(value)

		if(name === 'primary') {
			dados.current.info.color['primary_rgb'] = color_rgb
		}

		dados.current.info.color[name] = value

		set_dados(dados.current.info)
		setRefresh(refresh + 1)
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
		
	}

	function hex2rgb(value) {
		var hex_color = value
		var pattern_color = "^#([A-Fa-f0-9]{6})$";
		if (hex_color.match(pattern_color)) {
			var hex_color_aux = hex_color.replace("#", "")
				, r = parseInt(hex_color_aux.substring(0, 2), 16)
				, g = parseInt(hex_color_aux.substring(2, 4), 16)
				, b = parseInt(hex_color_aux.substring(4, 6), 16);
			return '' + r + ',' + g + ',' + b + '';
		}
		else {
			alert('Error Color Format');
		}
	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className='card'>

									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item d-none">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
													:
														null
												}
											</ul>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
													content_language.length > 0 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																	<div className="row mb-4">
																		<div className="col-6">
																			<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="title" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.title, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" required={el_lang.id === '1' ? 'required' : ''} />
																		</div>
																		<div className="col-2 d-none">
																			<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_tag}</label>
																			<input type="text" name="tag" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.tag} onChange={(e) => handle_change_info(e)} className="form-control rounded-0" />
																		</div>
																		<div className="col-2">
																			<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_less}</label>
																			<div className="input-group">
																			<input type="text" name="less" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.less} onChange={(e) => handle_change_info(e)} className="form-control rounded-0 text-end" />																				<span className='input-group-text rounded-0'>pontos</span>
																			</div>
																		</div>
																		<div className="col-2">
																			<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_more}</label>
																			<div className="input-group">
																			<input type="text" name="more" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.more} onChange={(e) => handle_change_info(e)} className="form-control rounded-0 text-end" />																				<span className='input-group-text rounded-0'>pontos</span>
																			</div>
																		</div>

																		{
																		el_lang.id === '1' || true ?
																			<div className="col-2"> 
																				<div className="d-flex">
																					<div className="mb-3 d-none">
																						<label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
																						<div className="input-group">
																							<label className="switch">
																								<input
																									id={'item-switch-active'}
																									name={"active"}
																									className=""
																									type="checkbox"
																									value={dados.current.info.active}
																									onChange={handleSingleCheckActive}
																									defaultChecked={dados.current.info.active}
																								/>
																								<span className="slider" htmlFor={'item-switch-active'}></span>
																							</label>
																						</div>
																					</div>

																					<div className="ms-3 mb-3">
																						<label className="fs-6 fw-bold mb-2">{language[lang].field_avaiable}</label>
																						<div className="input-group">
																							<label className="switch">
																								<input
																									id={'item-switch-avaiable'}
																									name={"avaiable"}
																									className=""
																									type="checkbox"
																									value={dados.current.info.avaiable}
																									onChange={handleSingleCheckAvaiable}
																									defaultChecked={dados.current.info.avaiable}
																								/>
																								<span className="slider" htmlFor={'item-switch-avaiable'}></span>
																							</label>
																						</div>
																					</div>
																					
																				</div>
																			</div>
																		:
																			null
																		}
																	</div>

																	<div className="row mb-4">
																		<div className="col-6">
																			<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<textarea type="text" rows="4" name="description" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.description, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" />
																		</div>
																		<div className="col-6">
																			<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_warning} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<textarea type="text" rows="4" name="warning" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.warning, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" />
																		</div>
																	</div>

																	{/*
																		<div className="row mb-3">
																			<div className="col-md-4">
																				<label className="fs-5 mb-2">{language[lang].color_primary}</label>
																				<div className="input-group">
																					<div className="me-3">
																						<input type="color" name="primary" value={dados.current.info?.color?.primary ? dados.current.info?.color?.primary : '#000000'} className="form-control p-0 border-0 rounded-0" style={{width: '34px', height: '34px'}} placeholder={language[lang].color_placeholder} onChange={handle_change_info_color} />
																					</div>
																					<span className="form-control rounded-0">{dados.current.info?.color?.primary}</span>
																				</div>
																			</div>

																			<div className="col-md-6">
																			</div>
																		</div>

																		<div className="row mb-3">
																			<div className="col-md-4">
																				<label className="fs-5 mb-2">{language[lang].color_secondary}</label>
																				<div className="input-group">
																					<div className="me-3">
																						<input type="color" name="secondary" value={dados.current.info?.color?.secondary ? dados.current.info?.color?.secondary : '#FFFFFF'} className="form-control p-0 border-0 rounded-0" style={{width: '34px', height: '34px'}}  placeholder={language[lang].color_placeholder} onChange={handle_change_info_color} />
																					</div>
																					<span className="form-control rounded-0">{dados.current.info?.color?.secondary}</span>
																				</div>
																			</div>

																			<div className="col-md-6">
																			</div>
																		</div>
																	*/}
																</div>
															)
														})
													:
														null
													}
												</div>
											</div>
										</form>
									</div>

								</div>
							</div>

						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
